import React from "react";
import { Card, PriceInput, Typography, Box, Button } from "@bca/ui-library";
import { layout } from "styled-system";
import styled from "styled-components";

import InvalidInputWarning from "./InvalidInputWarning";
import { inputIsInvalid } from "./inputIsInvalid";
import { getValidBidAmount } from "./getValidBidAmount";

interface ProxyBidCardProps {
  title: string;
  text: string;
  increment: number;
  buttonText: string;
  bidAmount: number;
  setBidAmount: (value: number) => void;
  onSubmit: () => void;
}

const CardWithLayout = styled(Card)<any>`
  ${layout}
`;

const ProxyBidCard: React.FunctionComponent<ProxyBidCardProps> = ({
  title,
  text,
  increment,
  buttonText,
  bidAmount,
  setBidAmount,
  onSubmit,
}) => {
  const onChange = (amount: number) => {
    setBidAmount(amount * 100);
  };
  const css = `
    font-weight: 700;
  `;
  const incrementDisplayValue = increment / 100;

  return (
    <CardWithLayout
      width="100%"
      height="auto"
      marginX={0}
      marginY={0}
      paddingX={["28px", "30px", "30px"]}
      paddingY={7}
      maxHeight={["100%", "100%", 245]}
    >
      <Typography variant="h6" css={css} mt={0} mb={3} color="footer-blue">
        {title}
      </Typography>
      <Typography variant="body" color="grey-blue" mt={0} mb={3}>
        {text}
      </Typography>
      <Typography variant="body" color="grey-blue" mt={0} mb={3}>
        {`£${incrementDisplayValue} Increments`}
      </Typography>
      <Box display="flex" flexDirection={["column", "column", "row"]}>
        <Box
          width={["100%", "100%", "197px"]}
          display="inline-flex"
          mr="18px"
          mb={["12px", "18px", 0]}
        >
          <PriceInput
            value={bidAmount ? bidAmount / 100 : 0}
            step={incrementDisplayValue}
            invalidInput={inputIsInvalid(bidAmount, increment)}
            onChange={onChange}
            decrementDisabled={bidAmount < increment}
            minimumInputValue={incrementDisplayValue}
          ></PriceInput>
        </Box>
        <Button
          variant="primary-gradient"
          width={["100%", 150]}
          paddingX={3}
          paddingY="11px"
          marginRight={[0, 0, "18px"]}
          fontSize="h6"
          onClick={onSubmit}
          disabled={inputIsInvalid(bidAmount, increment) || bidAmount === 0}
          data-en="click"
          data-ec="button"
          data-el="proxyBid"
          data-ea="open"
        >
          {buttonText}
        </Button>
      </Box>
      {inputIsInvalid(bidAmount, increment) && (
        <InvalidInputWarning
          text={`Bids can only be placed in increments of £${incrementDisplayValue}. The next valid bid is `}
          validBidAmount={getValidBidAmount(bidAmount, increment)}
          setBidAmount={setBidAmount}
        ></InvalidInputWarning>
      )}
    </CardWithLayout>
  );
};

export default ProxyBidCard;
